import React, { ReactElement } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormatService from '../../services/format-service';
import useStylesCheckboxLabel from './checkbox-label.styles';

const CheckboxLabel: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDark,
    isFullWidth,
    label,
    className,
    onClick,
    children,
  } = props;

  const { classes } = useStylesCheckboxLabel();

  const fullWidthClassName: string | undefined = isFullWidth ? classes.checkboxLabelFullWidth : undefined;
  const darkClassName: string | undefined = isDark ? classes.checkboxLabelDark : undefined;

  return (
    <FormControlLabel
      control={children}
      label={label || ''}
      className={FormatService.formatClassNames(fullWidthClassName, darkClassName, className)}
      onClick={onClick}
    />
  );
});

export default CheckboxLabel;
